<pdi-footer build="{{ApiFileVersion}} - Web.v {{BuildVersionFull}}" class="navbar-fixed-bottom"></pdi-footer>